import { atom } from "recoil";

const waterInTakeTrackingAtom = atom({
  key: "waterInTakeTracking",
  default: null,
});

export default waterInTakeTrackingAtom;
